import React, { useState } from 'react';

import { FormikErrors, FormikValues } from 'formik';

import LinearProgress from '@mui/material/LinearProgress';

import {
    useActivityCategory,
    useServiceClass,
    useServiceType,
    useObjectCategory,
    useStatuses,
} from '../../state/app/dictionaries/index.hooks';
import { useUserSettings } from '../../state/user/index.hooks';
import { ILocationEntity, ISourceSetEntity } from '../../state/types';
import {
    fetchLocationsRegister,
    resetLocationsRegister,
} from '../../state/_actions';

import { useAppDispatch } from '../../hooks';

import TaskFormFields from './components/TaskFormFields';
import GridSearchDialog from '../../components/dialogs/GridSearchDialog';
import { usePrivileges } from '../../state/auth/index.hooks';
import { useIsLocationsFetching } from '../../state/app/fetching/selectors/index.hooks';
import { useLocationsRegister } from '../../state/app/entities/selectors/index.hooks';
import { ITaskForm } from 'src/app/state/ui/forms';

interface IOwnProps {
    mode: 'add' | 'edit' | 'copy';
    isSubmitting: boolean;
    errors?: FormikErrors<ITaskForm>;
    values: FormikValues;
    setFieldValue: (field: string, value: any) => void;
    onAddLocation: (values: FormikValues) => void;
    routeAssigned?: boolean | null;
}
const TaskForm = ({
    mode,
    isSubmitting,
    errors,
    values,
    setFieldValue,
    onAddLocation,
    routeAssigned = null,
}: IOwnProps) => {
    const [isLocationsDialogOpen, setIsLocationsDialogOpen] = useState(false);

    const dispatch = useAppDispatch();

    const locationsRegister = useLocationsRegister();
    const isLocationsFetching = useIsLocationsFetching();
    const privileges = usePrivileges();
    const userSettings = useUserSettings();
    const activityCategory = useActivityCategory();
    const serviceClass = useServiceClass();
    const serviceType = useServiceType();
    const objectCategory = useObjectCategory();
    const statuses = useStatuses();

    const closeLocationsDialog = () => {
        setIsLocationsDialogOpen(false);
    };

    const confirmLocationsDialog = (
        data: ISourceSetEntity,
        setFieldValue: (field: string, value: any) => void
    ) => {
        closeLocationsDialog();
        const location = data as unknown as ILocationEntity;
        if (location.externalId) {
            setFieldValue('data.location', {
                id: +location.externalId,
                label: location.name,
            });
        }
    };

    const handleOpenLocations = () => {
        setIsLocationsDialogOpen(true);
    };
    if (isSubmitting || (mode !== 'add' && !values.activityCategory)) {
        return <LinearProgress />;
    }
    return (
        <React.Fragment>
            <GridSearchDialog
                sourceSet={locationsRegister}
                fetching={isLocationsFetching}
                isOpen={isLocationsDialogOpen}
                close={closeLocationsDialog}
                confirm={(data: ISourceSetEntity) =>
                    confirmLocationsDialog(data, setFieldValue)
                }
                fetchDataHandler={(filter: string) => {
                    dispatch(
                        fetchLocationsRegister({
                            name: filter,
                            limit: 500,
                        })
                    );
                }}
                onResetData={() => dispatch(resetLocationsRegister())}
                title="Search location"
            />
            <TaskFormFields
                activityCategory={activityCategory}
                serviceClass={serviceClass}
                serviceType={serviceType}
                objectCategory={objectCategory}
                privileges={privileges}
                statuses={statuses}
                onSelectLocation={handleOpenLocations}
                onAddLocation={() => onAddLocation(values)}
                errors={errors}
                values={values}
                setFieldValue={setFieldValue}
                dateFormat={userSettings.shortDateFormat}
                mode={mode}
                routeAssigned={routeAssigned}
            />
        </React.Fragment>
    );
};

export default TaskForm;
